import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/ui/Header";

/**
 * Chrome for the Etsy pages (/etsy and /etsy/done) and the gift link (/gift).
 *
 * An Etsy buyer arrives from one Etsy order to build one book, so there is
 * nothing to navigate to: no menu, and the logo is not a link. Every way out
 * (Home, How It Works, legal pages) leads somewhere with Shopify sign-in and
 * checkout buttons they have no use for.
 *
 * Deliberately not FrontLayout either: that layout bounces a signed-in visitor
 * to /dashboard, which would race the claim page's own navigation into the
 * wizard the moment a claim succeeds.
 */
const EtsyLayout = () => {
  return (
    // Full-height column so the footer sits at the bottom of short pages
    // instead of floating mid-screen.
    <div className="min-h-screen flex flex-col bg-md-pink-light-2">
      <Header sticky={false} />
      <div className="flex-1">
        <Outlet />
      </div>
      <footer className="flex items-center justify-center h-24 bg-md-pink-light-1 border-t border-md-pink-light-1 px-4">
        <div className="text-md-muted text-sm sm:text-base text-center">
          &copy; {new Date().getFullYear()} Memory Doodle. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default EtsyLayout;
